import { useLocation } from "react-router";
import { signUp, SignUpOptions } from "../signUp";

export interface SignUpFn {
  (options?: SignUpOptions): Promise<void>;
}

export const useSignUp = (): SignUpFn => {
  const location = useLocation();
  const currentPath = `${location.pathname}${location.search}`;

  return (options) => {
    const { target = currentPath, ...rest } = options || {};

    return signUp({ target, ...rest });
  };
};
